import { getUser } from "@synthesis/shared-auth";
import { setApiBaseUrl, setAuthTokenGetter } from "@synthesis/shared-services";

import { uriPrefix } from "./axios-instance";

/**
 * Один раз на старте приложения проводит base URL и источник Bearer-токена
 * в мутатор @synthesis/shared-services, чтобы сгенерированные хуки работали.
 * Значения апс-специфичны (env/Keycloak eacd), поэтому проводка живёт в приложении,
 * а не в shared-пакете. В другом проекте — свой такой же вызов.
 */
export const configureServices = (): void => {
  if (typeof uriPrefix === "string") {
    setApiBaseUrl(uriPrefix);
  }
  setAuthTokenGetter(() => getUser()?.access_token);
};
